import React from 'react'

export default function Podcast() {
  return (
    <div>
        <h2 style={{textAlign : 'center'}} > Listen Top Podcasts Here !! </h2>

<div style={{display : 'flex' , justifyContent : 'center' , flexWrap : 'wrap'}} >
<iframe style={{borderRadius : '12px' , width : "40%" , height : "242" , marginRight  :'20px' }} src="https://open.spotify.com/embed/episode/1qy8qBi4PhWhkOGbZ1TAbz?utm_source=generator"  frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>

<iframe style={{borderRadius : '12px' , width : "40%" , height : "242" }} src="https://open.spotify.com/embed/show/0A6kWKFEOFtp8fkrpnAJQB?utm_source=generator"  frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>

<iframe style={{borderRadius : '12px' , width : "40%" , height : "242" , marginTop : '10px' , marginRight : '20px' }} src="https://open.spotify.com/embed/show/6ZcvVBPQ2ToLXEWVbaw59P?utm_source=generator"  frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>

<iframe style={{borderRadius : '12px' , width : "40%" , height : "200px" , marginTop : '10px' }}  src="https://open.spotify.com/embed/show/69ZUhdV0q2JtibNU2yLTpQ?utm_source=generator" width="100%" height="232" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>


</div>

<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />



    </div>
  )
}
